const Config = {
  headerHeightMobile: 32,
  headerHeightDesktop: 32,
  desktopThresholdViewportWidth: '801px',
  smallTabletThresholdViewportWidth:  '501px',
  contactPhoneNumber: '+33757907550',
  mapsApiKey: 'AIzaSyD6m3jlHrFHX1tCPAWceGo-sDq14VWYC48'
}
export default Config
